import { LabsFlag } from '../../../enums/labsFlag'
import { useLabsMenuFlags } from '../../../hooks/useLabsMenuFlags'
import { useIsEInvoicingOnly } from '../../bills/hooks/useIsEInvoicingOnly'

export const useIsInvoicingSettingsModalEnabled = () => {
  const isEInvoicingOnly = useIsEInvoicingOnly()
  const labsFlags = useLabsMenuFlags()

  return labsFlags[LabsFlag.InvoicingSettings] && !isEInvoicingOnly
}
